import { SelectModelPage } from '../containers/selectModelPage';
import { TechDocChecklistPage, TechDocWizardPage } from '../containers/pages';
import {
  PRODUCT_ID_BAAS,
  PRODUCT_ID_BAAS_6K_B,
  PRODUCT_ID_BAAS_9K_M,
  ALLETRAMP_VIDEO_URL,
} from '../constants';
const gettingStartedPath = '/getting-started/';
const cloudEnablementPath = `${gettingStartedPath}cloud-enablement/`;
export const gettingStarted = (productId = '') => {
  let config = [];
  switch (productId) {
    case PRODUCT_ID_BAAS:
    case PRODUCT_ID_BAAS_6K_B:
    case PRODUCT_ID_BAAS_9K_M:
      config = baasGettingStarted();
      break;
    default:
      config = gettingStartedConfig();
  }
  return config;
};

function gettingStartedConfig() {
  const menuItemArray = [
    {
      path: '/getting-started',
      menuText: 'gettingStarted',
      exact: true,
      redirectTo: '/getting-started/select-model',
      submenuItems: [
        {
          path: '/getting-started/select-model',
          menuText: 'selectArrayModel',
          pageName: 'selectArrayModel',
          exact: true,
          component: SelectModelPage,
          pageProps: {},
        },
        {
          path: cloudEnablementPath,
          menuText: 'cloudenablement',
          exact: true,
          redirectTo: `${cloudEnablementPath}1`,
        },
        {
          path: `${cloudEnablementPath}:step`,
          exact: true,
          component: TechDocWizardPage,
          pageName: 'cloudenablement',
          pageProps: {
            steps: [
              {
                videoUrl: '',
                steptitle: 'Getting Started',
              },
              {
                videoUrl: '',
                steptitle: 'Create User Account',
              },
              {
                videoUrl: ALLETRAMP_VIDEO_URL.CLOUD_ENABLE_STEP3,
                steptitle: 'Create Workspace',
              },
              {
                videoUrl: ALLETRAMP_VIDEO_URL.CLOUD_ENABLE_STEP4,
                steptitle: 'Deploy Data Services Cloud Console',
              },
              {
                videoUrl: ALLETRAMP_VIDEO_URL.CLOUD_ENABLE_STEP5,
                steptitle: 'Assign Administrator',
              },
            ],
          },
        },
        {
          path: '/getting-started/checklist',
          menuText: 'preInstallation',
          exact: true,
          component: TechDocChecklistPage,
          pageProps: {},
        },
      ],
    },
  ];
  return menuItemArray;
}

function baasGettingStarted() {
  return [
    {
      path: '/getting-started',
      menuText: 'gettingStarted',
      exact: true,
      redirectTo: '/getting-started/select-model',
      submenuItems: [
        {
          path: '/getting-started/select-model',
          menuText: 'selectStorageTier',
          pageName: 'selectStorageTier',
          exact: true,
          component: SelectModelPage,
          pageProps: {},
        },
        {
          path: cloudEnablementPath,
          menuText: 'cloudenablement',
          exact: true,
          redirectTo: `${cloudEnablementPath}1`,
        },
        {
          path: `${cloudEnablementPath}:step`,
          exact: true,
          component: TechDocWizardPage,
          pageName: 'cloudenablement',
          pageProps: {
            steps: [
              {
                videoUrl: '',
                steptitle: 'Getting Started',
              },
              {
                videoUrl: '',
                steptitle: 'Create User Account',
              },
              {
                videoUrl: ALLETRAMP_VIDEO_URL.CLOUD_ENABLE_STEP3,
                steptitle: 'Create Workspace',
              },
              {
                videoUrl: ALLETRAMP_VIDEO_URL.CLOUD_ENABLE_STEP4,
                steptitle: 'Deploy Data Services Cloud Console',
              },
              {
                videoUrl: ALLETRAMP_VIDEO_URL.CLOUD_ENABLE_STEP5,
                steptitle: 'Assign Administrator',
              },
              {
                videoUrl: ALLETRAMP_VIDEO_URL.CLOUD_ENABLE_STEP6,
                videoUrl_subscribed:
                  ALLETRAMP_VIDEO_URL.CLOUD_ENABLE_STEP6_SUBSCRIBED,
                steptitle: 'Add the Device to Your Workspace',
              },
            ],
          },
        },
        {
          path: '/getting-started/siteReadiness',
          menuText: 'siteReadiness',
          exact: true,
          component: TechDocChecklistPage,
          pageProps: {},
        },
        {
          path: '/getting-started/checklist',
          menuText: 'preInstallation',
          exact: true,
          component: TechDocChecklistPage,
          pageProps: {},
        },
      ],
    },
  ];
}
